<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="float-left">02. Household Information</h5>
<!--        <div class="float-right mb-1">-->
<!--            <div v-if="households.length > 0">-->
<!--              <span class="badge badge-success mr-2">Total Search Data Found: {{ households.length }}</span>-->
<!--              <download-excel-->
<!--                      class = "btn btn-light"-->
<!--                      :data = "households"-->
<!--                      :fields = "household_fields"-->
<!--                      :meta="json_meta"-->
<!--                      worksheet = "Household Family Member"-->
<!--                      name = "household-family-member.xls">-->
<!--                Download Excel-->
<!--              </download-excel>-->
<!--            </div>-->
<!--          </div>-->
      </div>
    </div>
    <p v-if="households.length === 0">N/A</p>
    <div class="scrollable-table" v-if="households.length > 0">
      <table class="table table-bordered table-hover dt-table table-striped table-long table-sm">
        <thead>
          <tr>
            <th>#</th>
            <th>HH Name</th>
            <th>Relation</th>
            <th>Gender</th>
            <th>Age</th>
            <th>Education</th>
            <th>Marital Status</th>
            <th>Main Occupation</th>
            <th>Secondary Occupation</th>
            <th>Annual Income</th>
            <th>IS HH</th>
          </tr>
        </thead>
        <tbody>
          <tr li v-for="(househ, index) in households" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ househ.full_name }}</td>
            <td>{{ househ.family_relation.desc }}</td>
            <td>{{ househ.gender.desc }}</td>
            <td>{{ househ.age }}</td>
            <td>{{ househ.education.desc }}</td>
            <td>{{ househ.maritial_status.desc }}</td>
            <td>{{ househ.occupation.desc }}</td>
            <td>
              <span v-for="(occu, index) in househ.sec_occupations" :key="index"
                >{{ occu.desc }}
                {{ index + 1 != househ.sec_occupations.length ? " ," : "" }}
              </span>
            </td>
            <td>{{ househ.yearly_income }}</td>
            <td>
              <span v-if="househ.is_household_head === 1">Yes</span>
              <span v-if="househ.is_household_head === 0">No</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import http from "@state/http";

export default {
  data() {
    return {
      households: [],
      household_fields: {
        'HH Name': 'full_name',
        'Relation': 'family_relation.desc',
        'Gender': 'gender.desc',
        'Age': 'age',
        'Education': 'education.desc',
        'Marital Status': 'maritial_status.desc',
        'Main Occupation': 'occupation.desc',
        'Annual Income': 'yearly_income',
        'IS HH' : {
          callback: (value) => {
            if (value.is_household_head === 1){
              return `Yes`;
            }else{
              return `No`;
            }
          }
        },
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },

  mounted() {
    this.getPersonHhold();
  },
  methods: {
    getPersonHhold() {
      http
        .get("api/ses/households/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.households = response.data.houseHold;
          }
        });
    }
  },
};
</script>
